import { Button } from '@farol-ds/react'
import { FormEvent, useCallback, useState } from 'react'

import { parseErrorMessage } from '../../utils/parseErrorMessage'
import { getEmailErrorMessage } from '../../utils/validation'
import { EmailField } from '../email-field'
import { LoginCard } from '../login-card'
import styles from './forgot-password.module.scss'

export interface ForgotPasswordProps {
  email: string
  isLoading?: boolean
  error?: string
  onSubmit: (email: string) => Promise<void>
  onCloseClick?: () => void
}

export function ForgotPassword({
  email,
  isLoading,
  error,
  onSubmit,
  onCloseClick,
}: ForgotPasswordProps) {
  const [emailValue, setEmailValue] = useState(email)
  const [emailTouched, setEmailTouched] = useState(false)
  const [emailError, setEmailError] = useState<string | undefined>()

  const handleEmailBlur = useCallback(() => {
    setEmailTouched(true)
    setEmailError(getEmailErrorMessage(emailValue))
  }, [emailValue])

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    setEmailTouched(true)
    const message = getEmailErrorMessage(emailValue)
    setEmailError(message)
    if (message) return
    await onSubmit(emailValue)
  }

  const parsedError = error ? parseErrorMessage(error) : null
  const header = {
    title: 'Esqueceu a senha?',
    subtitle: {
      content: <>Enviaremos um e-mail com instruções de como redefinir sua senha.</>,
    },
    ...(parsedError && {
      errorMessage: {
        title: parsedError.title,
        description: parsedError.description,
      },
    }),
  }

  return (
    <LoginCard header={header} onCloseClick={onCloseClick}>
      <div className={styles.content}>
        <form onSubmit={handleSubmit} className={styles.form} noValidate>
          <EmailField
            value={emailValue}
            onChange={setEmailValue}
            onBlur={handleEmailBlur}
            error={emailTouched ? emailError : undefined}
            disabled={isLoading}
          />

          <Button type="submit" kind="primary" loading={isLoading} className={styles.submitButton}>
            Continuar
          </Button>
        </form>
      </div>
    </LoginCard>
  )
}
